import type { ApiSession } from '../auth/apiSession';

let session: ApiSession | undefined;

export function configureAdminFetch(apiSession: ApiSession) {
  session = apiSession;
}

/** All admin requests acquire a current token, including calls from idle pages. */
export async function adminFetch(
  url: string,
  init?: RequestInit,
): Promise<Response> {
  if (!session) {
    throw new Error('API authentication has not been initialized.');
  }
  const currentSession = session;
  const accountId = currentSession.getSnapshot().accountId;
  const token = await currentSession.getToken();
  if (accountId !== currentSession.getSnapshot().accountId) {
    throw new Error('The signed-in account changed. Please try again.');
  }
  const headers = new Headers(init?.headers);
  // Existing page callers pass a snapshot token. Never send that possibly
  // expired value: MSAL is the authority for the token used by this request.
  headers.set('Authorization', `Bearer ${token}`);
  const response = await fetch(url, { ...init, headers });
  if (response.status === 401) {
    if (accountId === currentSession.getSnapshot().accountId) {
      currentSession.rejectToken(token);
    }
    // Do not automatically replay administrative writes after a 401.
    throw new Error('Your session was rejected. Sign in again and retry.');
  }
  return response;
}
